import {CoolDownFlag} from '../CoolDownFlag'
import {Flag} from '../Flag'
import {getKlaviyoScript} from '../getKlaviyoScript'

/**
 * I'll convert a number of days into milliseconds
 * @param {number|string} days
 * @return {number}
 */
function daysToMilliSeconds(days) {
	return parseInt(days) * 24 * 60 * 60 * 1000
}

export function initNewsletterPopup() {
	$('[data-newsletter-popup]').once('popupNewsletter').each(function () {
		const $popup = $(this)
		const $content = $popup.find('.newsletter-popup__content')
		const $message = $popup.find('.newsletter-popup__message')
		const $form = $popup.find('form')

		const period = daysToMilliSeconds($popup.data('newsletterPopupCooldown') || 7)
		const isCoolingDown = new CoolDownFlag('newsletterPopup.cooledDownAt', period)
		const wasSubmitted = new Flag('newsletterPopup.wasSubmitted')

		if (!isCoolingDown.isSet() && !wasSubmitted.isSet()) {
			getKlaviyoScript('//www.klaviyo.com/media/js/public/klaviyo_subscribe.js').then(() => {
				// noinspection JSUnresolvedVariable
				KlaviyoSubscribe.attachToForms($form.get(0), {
					hide_form_on_success: true,
					extra_properties: {
						'$source': 'newsletter'
					}
				})
			})

			$form.on('klaviyo.subscribe.success klaviyo.subscribe.error', function () {
				$content.hide()
				$message.show()
				wasSubmitted.set()
			})

			$popup.on('hide.bs.modal', function () {
				isCoolingDown.set()
			})

			$popup.modal('show')
			$form.find('.newsletter-popup__email-address').focus()
		}

		// Allow the theme customizer to force the newsletter popup open so that
		// designers can see what they are doing
		document.addEventListener('shopify:section:select', function (event) {
			if (event.detail.sectionId === 'newsletter-popup') {
				$popup.modal('show')
			}
		})

		document.addEventListener('shopify:section:deselect', function (event) {
			console.log(event)
			if (event.detail.sectionId === 'newsletter-popup') {
				$popup.modal('hide')
			}
		})
	})
}